module.exports = __webpack_public_path__ + "static/CLIENT SERVICE AGREEMENT-3fba2b081d7d8d5229a93a515ad59c0c.pdf";